export const APP_REGEX = {
    currency: /^[0-9]+(\.[0-9]{1,2})?$/
}


// WEBPACK FOOTER //
// ./src/app/contants/APP_REGEX.ts